import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import * as api from '../api';

//액션 타입
const GET_USER_INFO = 'GET_USER_INFO';
const USER_AUTH = 'USER_AUTH';
const INITIALIZE_USER_STATE = 'INITIALIZE_USER_STATE';
//액션 생성자
export const GetUserInfo = createAction(GET_USER_INFO, api.getUser);
export const UserAuth = createAction(USER_AUTH, api.userAuth);
export const initializeUserState = createAction(INITIALIZE_USER_STATE, sliceStoreName => sliceStoreName)
export const defalutUserState = {
    userData: null,
    status: 'PENDING',
}

export default handleActions({
    [ initializeUserState().type ]: (state, { payload: { sliceStoreName, defaultState } }) => {
        return Object.assign({},state,{
            [sliceStoreName]: defaultState
        })
    },
    ...pender({
        type: GET_USER_INFO,
        onPending: (state) => {
            return Object.assign({},state,{
                status : 'PENDING'
            })
        },
        onSuccess: (state, action) => {
            if (action.payload){
              const {data} = action.payload;
              return Object.assign({},state,{
                  userData : data,
                  status: 'DONE',
              })
            } else {
              return Object.assign({},state,{
                  userData : null,
                  status: 'DONE',
              })
            }
        
        },
        onFailure:  (state, action) => {
            return Object.assign({},state,{
              status : 'DONE'
            })
        }
    }),
    ...pender({
        type: USER_AUTH,
        onPending: (state) => {
            return Object.assign({},state,{
                status : 'PENDING'
            })
        },
        onSuccess: (state, action) => {
            const { data } = action.payload;
            if (data){
              return Object.assign({},state,{
                  userData : data,
                  status: 'DONE',
              })
            } else {
              return Object.assign({},state,{
                  userData : null,
                  status: 'DONE',
              })
            }
        },
        onFailure:  (state, action) => {
            return Object.assign({},state,{
              status : 'DONE'
            })
        }
    }),
}, defalutUserState);
